const mj_config = {
    getBaseUrl() {
        let baseUrl;
        if (process.env.NODE_ENV === 'development') {
            baseUrl = `http://${window.location.hostname}:8181`;
        }
        else { baseUrl = `https://${window.location.hostname}`; }
        return baseUrl
    }
    ,
    //disabilitiamo o abilitiamo a livello globale il csv exporting 
    csv_global_export_enabled(){return false;}, 

}
export default mj_config;
